import { twMerge } from 'tailwind-merge';

export interface FooterLinkProps {
  to: string;
  label: string;
  className?: string;
}

export const FooterLink = (props: FooterLinkProps) => {
  return (
    <a
      href={props.to}
      target="_blank"
      className={twMerge('text-white underline transition-colors hover:text-lime md:font-bold', props.className)}
    >
      <span className="text-base font-bold sm:text-[14px] sm:leading-[21px]">{props.label}</span>
    </a>
  );
};
